import { schBasementAtticFinishTypes } from '@aloft/toolkit-shared';
import { SimpleSelect, toOpts } from '@aloft/toolkit-sui';

import { UseFormRegister } from 'react-hook-form';

import { ObjectiveCharacteristicsFormInput } from '../schObjectiveCharacteristics.ts';

export const BasementAtticTypeSelect = ({
  register,
  name,
  onChange,
}: {
  register: UseFormRegister<ObjectiveCharacteristicsFormInput>;
  name: 'basement.type' | 'attic.type';
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}) => {
  const { onChange: registerOnChange, ...rest } = register(name);

  return (
    <SimpleSelect
      {...rest}
      onChange={(event) => {
        registerOnChange(event);
        onChange?.(event);
      }}
      label="Type"
      size="sm"
      required
    >
      {toOpts(schBasementAtticFinishTypes.options).map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </SimpleSelect>
  );
};
